// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
export const UNIFIED_EXPORT_FORMAT_MIME = {
    pdf: 'application/pdf',
    csv: 'text/csv',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    zip: 'application/zip',
    json: 'application/json',
};
export const UNIFIED_EXPORT_FORMAT_EXTENSION = {
    pdf: 'pdf',
    csv: 'csv',
    docx: 'docx',
    xlsx: 'xlsx',
    zip: 'zip',
    json: 'json',
};
export const UNIFIED_EXPORT_FORMAT_LABEL = {
    pdf: 'PDF',
    csv: 'CSV',
    docx: 'Word (DOCX)',
    xlsx: 'Excel (XLSX)',
    zip: 'ZIP archive',
    json: 'JSON',
};
//# sourceMappingURL=export-format.js.map